import React from 'react'

import { Box, Typography, Link } from '@material-ui/core'

import { useHistory } from 'react-router-dom'
import { routes } from 'routes'

import useCollapse from 'hooks/useCollapse'
import { Collapse } from 'components'
import CollapseHeader from './components/CollapseHeader'
import CollapseBody from './components/CollapseBody'
import Footer from './components/Footer'

import DetachedInvoiceContext from 'contexts/DetachedInvoiceContext'

const DetachedInvoiceSelectPlan = () => {
  const history = useHistory()
  const collapse = useCollapse()
  const context = React.useContext(DetachedInvoiceContext)

  const handleClickPrevButton = () => {
    history.push(routes.invoices.steps.selectCustomer)
  }

  const handleClickNextButton = () => {
    context.setData(data => ({
      ...data,
      plans: collapse.data,
    }))
    history.push(routes.invoices.steps.settings)
  }

  const disabledNextButton = collapse.data.some(
    item => item.collapseSettings.edit,
  )

  const handleClickAddPlan = () => {
    collapse.add({
      plan: null,
      periodicity: '',
      quantity: '',
      price: 0,
      contractPlanEntries: [{ quantity: '', price: 0 }],
      collapseSettings: { edit: true },
    })
  }

  React.useEffect(() => {
    if (collapse.data && collapse.data.length) {
      return
    }

    collapse.add({
      plan: null,
      description: '',
      from: null,
      till: null,
      entryType: '',
      price: 0,
      collapseSettings: { edit: true },
    })
  }, [collapse])

  return (
    <Box p={3}>
      <Collapse collapseHeader={CollapseHeader} collapseBody={CollapseBody} />
      <Box py={3}>
        <Link component="button" onClick={handleClickAddPlan}>
          <Typography variant="body2" color="secondary">
            ADICIONAR PLANO
          </Typography>
        </Link>
      </Box>
      <Footer
        prevButtonProps={{
          onClick: handleClickPrevButton,
        }}
        nextButtonProps={{
          onClick: handleClickNextButton,
          disabled: disabledNextButton,
        }}
      />
    </Box>
  )
}

export default DetachedInvoiceSelectPlan
